/* import __COLOCATED_TEMPLATE__ from './context-updated-conversation-item.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import Component from '@glimmer/component';
import type { FormattedConversationContextUpdated } from '../conversation-item';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export interface ConversationArgs {
  conversationItem: FormattedConversationContextUpdated;
}

interface Signature {
  Args: ConversationArgs;
  Element: HTMLElement;
}

export default class ContextUpdatedConversationItem extends Component<Signature> {
  @tracked isExpanded = false;

  get fieldCount() {
    return Object.keys(this.args.conversationItem.updates ?? {}).length;
  }

  get formattedUpdates() {
    return JSON.stringify(this.args.conversationItem.updates ?? {}, null, 2);
  }

  @action
  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::VoicePlayground::ConversationItems::ContextUpdatedConversationItem': typeof ContextUpdatedConversationItem;
  }
}
